import './styles/graphic.scss';
import mapboxgl from 'mapbox-gl';

const drawMap = async (container, isMobile) => {
  const fetchOutlookData = async (url) => {
    try {
      const response = await fetch(url);
      const data = await response.json();
      return data;
    } catch (error) {
      console.error('Error fetching outlook data:', error);
    }
  };

  const urls = {
    '6-10-day': 'https://ix.cnn.io/data/temp-outlook-map/us_temp_outlook_6_10_day.json',
    '8-14-day': 'https://ix.cnn.io/data/temp-outlook-map/us_temp_outlook_8_14_day.json',
    '3-4-week': 'https://ix.cnn.io/data/temp-outlook-map/snapshots/us_temp_outlook_3_4_week_111825.json',
  };

  const outlookData6to10 = await fetchOutlookData(urls['6-10-day']);
  const outlookData8to14 = await fetchOutlookData(urls['8-14-day']);
  const outlookData3to4Week = await fetchOutlookData(urls['3-4-week']);
  // console.log(outlookData3to4Week);
  // Set the initial state to 6-10 day data
  const initialOutlookData = outlookData6to10;
  // console.log(outlookData3to4Week);
  const timestampString = `Note: Forecast of the continental United States issued on ${outlookData3to4Week.forecast_issued} and valid from November 29 to December 12, 2025.`;

  document.getElementById('timestamp').textContent = timestampString;
  // const subhedDekElement = document.querySelector('.subhed.dek');
  // if (subhedDekElement) {
  //   subhedDekElement.innerHTML = initialOutlookData.msg;
  // }

  mapboxgl.accessToken = 'pk.eyJ1IjoiY25uZGlnaXRhbCIsImEiOiJiYjIwMTgxNDZmNjgyODllMjAxYTYwOTAxYmY2MzI2MyJ9.8F6TQITXymFzCXy8tBqGgg';

  const optionsSm = {
    initZoom: 2,
    minZoom: 2,
    maxZoom: 7,
    center: [-95.5, 38.5],
    maxBounds: [[-180, 0], [-20, 52]],
  };

  const optionsLg = {
    initZoom: 3.2,
    minZoom: 2,
    maxZoom: 7,
    center: [-97, 38.5],
    maxBounds: [[-180, 0], [-20, 52]],
  };

  const options = isMobile ? optionsSm : optionsLg;

  const map = new mapboxgl.Map({
    container: container.node(),
    style: 'mapbox://styles/cnndigital/clxtf0b6p00q701puf7oz2ts9',
    center: options.center,
    zoom: options.initZoom,
    maxZoom: options.initZoom,
    minZoom: options.initZoom,
    maxBounds: options.maxBounds,
    dragPan: false,
    interactive: false,
    projection: 'albers',
  });

  map.dragRotate.disable();
  map.touchZoomRotate.disableRotation();
  map.scrollZoom.disable();

  if (!isMobile) {
    const nav = new mapboxgl.NavigationControl({
      showCompass: false,
    });
    // map.addControl(nav, 'top-left');
  }

  const addOutlookLayer = (sourceId, layerIdPrefix, sourceLayerName, url, visibility = 'none') => {
    map.addSource(sourceId, {
      type: 'vector',
      url,
    });

    const categories = ['Above', 'Below', 'Normal'];
    const colors = {
      Above: ['#FFE8DF', '#FFD3C3', '#F89A8B', '#E6655A', '#C52622', '#9A040B', '#670000'],
      Below: ['#DDF3FA', '#BBE6F8', '#8CC8F6', '#5194C3', '#166296', '#01446D', '#042853'],
      Normal: ['#e4e5e4', '#c4c4c4', '#a2a2a2', '#808080', '#666666'],
    };

    categories.forEach((cat) => {
      map.addLayer({
        id: `${layerIdPrefix}-${cat.toLowerCase()}`,
        type: 'fill',
        source: sourceId,
        'source-layer': sourceLayerName,
        layout: {
          visibility,
        },
        filter: ['match', ['get', 'cat'], [cat], true, false],
        paint: {
          'fill-color': [
            'interpolate',
            ['linear'],
            ['get', 'prob'],
            30, colors[cat][0],
            40, colors[cat][1],
            50, colors[cat][2],
            60, colors[cat][3],
            70, colors[cat][4],
            80, colors[cat][5] || colors[cat][4], // Handle 80% if defined
            90, colors[cat][6] || colors[cat][5] || colors[cat][4], // Handle 90% if defined
          ],
          'fill-opacity': cat === 'Normal' ? 0.7 : 0.9,
        },
      });
      map.moveLayer(`${layerIdPrefix}-${cat.toLowerCase()}`, 'jk-us-state-labels-v2');
    });
  };

  const updateLegend = (data) => {
    const legendContainer = document.querySelector('.legend-container');
    legendContainer.innerHTML = '';

    const categories = ['Above', 'Below', 'Normal'];
    const colors = {
      Above: ['#FFE8DF', '#FFD3C3', '#F89A8B', '#E6655A', '#C52622', '#9A040B', '#670000'],
      Below: ['#DDF3FA', '#BBE6F8', '#8CC8F6', '#5194C3', '#166296', '#01446D', '#042853'],
      Normal: ['#e4e5e4', '#c4c4c4', '#a2a2a2', '#808080', '#666666'],
    };

    const availableCategories = categories.filter(cat => data.some(d => d.cat === cat));


    availableCategories.forEach((cat) => {
      const categoryData = data.filter(d => d.cat === cat);
      const probs = [...new Set(categoryData.map(d => d.prob))].sort((a, b) => a - b);
      console.log(cat, probs);

      const section = document.createElement('div');
      section.className = 'legend-section';

      const label = document.createElement('div');
      label.className = 'legend-section-label';
      label.textContent = cat === 'Above' ? 'Above normal' : cat === 'Below' ? 'Below normal' : 'Near normal';
      section.appendChild(label);

      const itemsContainer = document.createElement('div');
      itemsContainer.className = 'legend-items';

      probs.forEach((prob, index) => {
        const legendItem = document.createElement('div');
        legendItem.className = 'legend-item';

        const colorBox = document.createElement('span');
        colorBox.style.backgroundColor = colors[cat][index];
        legendItem.appendChild(colorBox);

        if (!(cat === 'Normal' && probs.length === 1)) {
          const probLabel = document.createElement('div');
          probLabel.textContent = `${prob}%`;
          legendItem.appendChild(probLabel);
        }

        itemsContainer.appendChild(legendItem);
      });

      section.appendChild(itemsContainer);
      legendContainer.appendChild(section);
    });
  };

  map.on('load', () => {
    // updated this to be a snapshot instead of live layer
    addOutlookLayer('3-4-week-outlook', '3-4-week', 'us-temp-outlook-3-4-week-111825', 'mapbox://cnndigital.0bm2r1x9', 'visible');

    // Move state boundaries and labels above the visualization layers
    map.moveLayer('state-innerlines');
    map.moveLayer('jk-us-outline-conus-v2');

    const forecastButtons = document.querySelectorAll('.forecast.button');

    const toggleLayerVisibility = (layerPrefix, visibility) => {
      ['above', 'below', 'normal'].forEach((cat) => {
        map.setLayoutProperty(`${layerPrefix}-${cat.toLowerCase()}`, 'visibility', visibility);
      });
    };

    const updateForecast = (event) => {
      const t = event.target.dataset.layer;
      toggleLayerVisibility('6-10-day', 'none');
      toggleLayerVisibility('8-14-day', 'none');
      toggleLayerVisibility(t, 'visible');
      forecastButtons.forEach(b => b.classList.remove('active'));
      event.target.classList.add('active');

      document.getElementById('timestamp').textContent = timestampString;

      if (t === '6-10-day') {
        if (subhedDekElement) {
          subhedDekElement.innerHTML = outlookData6to10.msg;
        }
        updateLegend(outlookData6to10.data);
      } else if (t === '8-14-day') {
        if (subhedDekElement) {
          subhedDekElement.innerHTML = outlookData8to14.msg;
        }
        updateLegend(outlookData8to14.data);
      }
    };

    // forecastButtons.forEach((button) => {
    //   button.addEventListener('click', updateForecast);
    // });

    // document.querySelector('.forecast.button[data-layer="6-10-day"]').classList.add('active');
    // document.getElementById('mapbtns').classList.add('show');

    // Initialize legend with 6-10 day outlook data
    updateLegend(outlookData3to4Week.data);


    // Ensure proper sizing for pym
    window.pymChild && window.pymChild.sendHeight();
  });
};

export default function (props, container, isMobile) {
  const {
    initialWidth,
    initialHeight,
  } = props;

  container.html(''); // Clear previous content
  container.append('div')
    .attr('id', 'map')
    .style('width', `${initialWidth}px`)
    .style('height', `${initialHeight}px`);

  drawMap(container.select('#map'), isMobile); // Pass the D3 selection of the map div
}
